import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './AppRelease7';
import './styles.css';
import './auth.css';
import './identity.css';
import './space-admin.css';
import './library.css';
import './billing.css';
import './billing-room.css';
import './chat.css';
import './events.css';
import './physical-place.css';
import './physical-place-extra.css';
import './room-share.css';
import './shell-stability.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const legacyV3 = window.location.pathname.startsWith('/v3/');
    const script = legacyV3 ? '/v3/sw.js' : '/sw.js';
    const scope = legacyV3 ? '/v3/' : '/';
    navigator.serviceWorker.register(script, { scope }).catch(() => undefined);
  });
}
